<template>
  <div class="display-container" :style="{ backgroundImage: `url(${data.backgroundImage}?1)` }">
    <div ref="swiperRef" class="swiper-container">
      <div class="swiper-wrapper flex">
        <div
          v-for="(item, index) of dataList"
          :key="item.id"
          class="swiper-slide"
          :class="{
            active: activeIndex + 1 === index,
          }"
        >
          <img :src="item.logo || item.systemLogo" alt="" class="logo" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
    dataList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
  mounted() {
    let swiper = new Swiper(this.$refs.swiperRef, {
      autoplay:
        this.$props.dataList.length > 3
          ? {
              delay: 3000,
              disableOnInteraction: false,
              allowTouchMove: true,
            }
          : false,
      slidesPerView: 3,
      on: {
        slideChange: () => {
          this.activeIndex = swiper.activeIndex
        },
      },
    })
  },
  methods: {},
}
</script>

<style scoped lang="less">
.flex {
  display: flex;
}
.display-container {
  margin: 0 auto;
  width: 686px;
  height: 414px;
  background-size: 100% 100%;

  .swiper-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .swiper-wrapper {
      width: 686px;
      height: 324px;
      padding: 32px 24px;
      margin-top: 90px;
      align-items: flex-end;
    }

    .swiper-slide {
      margin-right: 18px;
      width: 196px !important;
      height: 240px;
      background: #f9f9f9;
      border-radius: 12px;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &.active {
        width: 216px !important;
        height: 260px;

        .logo {
          width: 140px;
          height: 140px;
        }
      }
    }

    .logo {
      width: 112px;
      height: 112px;
      object-fit: cover;
      border-radius: 50%;
    }

    .name {
      font-weight: 500;
      font-size: 24px;
      color: #222222;
      line-height: 34px;
      margin-top: 14px;
      width: 152px;
      text-align: center;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>
